<template>
    <van-popup 
            v-model="showPopup"
            type="primary"
            class="my-popup"
            position="bottom"
            @close="doReject" @click-overlay="doReject"
        >
        <div class="popUnLogin talk-pop">
            <van-row class="talk-pop-head">
                <van-col span="6"><a class="ta-left" href="javascript:;" @click="closePopup">取消</a></van-col>
                <van-col span="12" class="ta-center">股神话大盘</van-col>
                <van-col span="6" class="ta-right"><a class="ta-right" href="javascript:;" @click="submit">确定</a></van-col>
            </van-row>
            <k-textarea placeholder="在这里说出您的观点" @on-change="textareName" :value="content" :rows="4" :max="200" autofocus></k-textarea>
        </div>
    </van-popup >
</template>
<script>
    import {
        commentPost
    } from '../../../api/g/comment'
    import { trim } from '../../../utils/base'
    export default {
        props: {
            objType: {type: [Number, String], default: 0},
            objId: {type: [Number, String], default: 0},
        },
        data() {
            return {
                showPopup : false,
                resolve: null,
                reject: null,
                disabled : false,
                content : ''
            }
        },
        methods: {
            getContainer() {
                return document.querySelector('body')
            },
            closePopup(){
                this.showPopup = false
                this.doReject()
            },
            textareName(val){
                this.content = val
            },
            async submit() {
                const {content, objType, objId} = this
                const query = {
                    content, objType, objId
                }
				if(trim(content)===''){
                    this.$toast('请输入内容')
                    return
                }
                try {
                    const R = await commentPost(query)
                    this.content = ''
                    this.doResolve(R)
                    this.$emit('success', R)
					this.showPopup = false
                } catch (error) {
                    this.$toast({
                        message : error.message || error.error_code,
                        position : 'bottom'
                    })
                    this.$emit('fail', error)
					this.doReject(error)
                }
				
            },
            show(type) {
                this.showPopup = true
                this.betType = type
                return new Promise((resolve, reject) => {
                    if (this.reject) {
                        this.reject()
                    }
                    this.resolve = resolve
                    this.reject = reject
                })
            },
            doResolve(val) {
                if (this.resolve) {
                    this.resolve(val)
                }
                this.clearPromiseState()
            },
            doReject(val) {
                if (this.reject) {
                    this.reject(val)
                }
                this.clearPromiseState()
            },
            clearPromiseState() {
                this.resolve = null
                this.reject = null
            }
        }
    }
</script>
<style lang="less" scoped>
    .my-popup {
        background:#f5f5f5;
        padding: 0 0.3rem 0.2rem 0.3rem;
		color : #222;
    }
    .talk-pop .talk-pop-head {
        padding: 0.2rem;
    }
    .talk-pop .talk-pop-head a {
        color: #666;
    }
    .btns {
        .van-button {
            width : 3rem;
        }
    }
</style>